module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "otherFutureLosses"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item--third"
  }, [_c('div', {
    staticClass: "u-margin-bottom-20 u-bold"
  }, [_vm._v("\n                    Are there any other future losses?\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "future_losses",
      "table-control": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasOtherFutureLosses),
      expression: "hasOtherFutureLosses"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "future_losses",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasOtherFutureLosses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])])], 1)]), _vm._v(" "), (_vm.hasOtherFutureLosses) ? _c('div', [_c('future-pension', {
    staticClass: "u-margin-bottom-40"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-care'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-services'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('future-purchases')], 1) : _vm._e()]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2475a4ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/OtherFutureLosses.vue
// module id = 1611
// module chunks = 0